(() => {
  const send = window.fetch.bind(window);
  const keys = ['Prénom de l’animal', 'Année de naissance', 'Photo de l’animal', 'Indications pour le studio', '_Droits photo confirmés'];
  let pending;
  const prepare = event => {
    const form = event.type === 'submit' ? event.target : event.target.closest?.('button[type="submit"], input[type="submit"]')?.form;
    if (!form?.querySelector('lf-personalization[data-duo-enabled]')) return;
    if (!form.reportValidity()) {
      pending = null;
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    pending = { form, expires: Date.now() + 15000 };
  };
  window.addEventListener('click', prepare, true);
  window.addEventListener('submit', prepare, true);
  const append = (data, key, value) => {
    if (value == null) return;
    if (value instanceof Blob) data.append(key, value);
    else if (typeof value === 'object') Object.entries(value).forEach(([part, child]) => append(data, `${key}[${part}]`, child));
    else data.append(key, String(value));
  };

  window.fetch = function (input, options) {
    let url;
    try { url = new URL(input instanceof Request ? input.url : input, location.href); } catch { return send(input, options); }
    if (url.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(url.pathname) || typeof options?.body !== 'string') return send(input, options);
    let payload;
    try { payload = JSON.parse(options.body); } catch { return send(input, options); }
    if (!Array.isArray(payload.items) || payload.items.length < 1 || payload.items.length > 2) return send(input, options);
    const form = document.querySelector('lf-personalization[data-duo-enabled]')?.closest('form');
    const selected = document.querySelector('.moonbundle-option-active');
    if (!form || !selected || !/Mon (?:hoodie|sweat)|Duo Favori|Duo Complice|Duo Junior/.test(selected.textContent)) return send(input, options);
    const fields = new FormData(form);
    const name = fields.get('properties[Prénom de l’animal]');
    if (!name || pending?.form !== form || Date.now() > pending.expires) return send(input, options);
    if (!form.reportValidity()) return Promise.reject(new Error('Veuillez compléter les informations de votre animal.'));
    const photo = fields.get('properties[Photo de l’animal]');
    if (!(photo instanceof File) || !photo.size) return Promise.reject(new Error('Veuillez choisir une photo de votre animal.'));
    for (const item of payload.items) {
      item.properties = { ...item.properties };
      for (const key of keys) {
        const value = fields.get(`properties[${key}]`);
        if (value !== null) item.properties[key] = value;
      }
      if (payload.items.length === 2) delete item.properties._Collection;
    }
    const body = new FormData();
    Object.entries(payload).forEach(([key, value]) => append(body, key, value));
    const headers = new Headers(options.headers);
    headers.delete('Content-Type');
    return send(input, { ...options, headers, body });
  };
})();

// Keep the app's displayed terminology aligned with the storefront.
(() => {
  const option = '[id="moonbundle-option"]';
  const labels = '.moonbundle-option-title, .moonbundle-option-subtitle';
  const replaceLabel = root => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    const targets = root.matches(labels) ? [root] : Array.from(root.querySelectorAll(labels));
    targets.forEach(label => {
      if (!label.closest(option)) return;
      const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const next = node.data.replace(/\bhoodies?\b/gi, word => {
          const singular = word.toLowerCase() === 'hoodie';
          let result = singular ? 'sweat' : 'sweats';
          if (word === word.toUpperCase()) result = result.toUpperCase();
          else if (/^[A-Z]/.test(word)) result = result[0].toUpperCase() + result.slice(1);
          return result;
        });
        if (node.data !== next) node.data = next;
      }
    });
  };
  const start = () => {
    replaceLabel(document.body);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'characterData') {
          const label = record.target.parentElement?.closest(labels);
          if (label) replaceLabel(label);
        } else {
          record.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) replaceLabel(node);
            else if (node.nodeType === Node.TEXT_NODE) {
              const label = node.parentElement?.closest(labels);
              if (label) replaceLabel(label);
            }
          });
        }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
